import { pdfProtectionStates } from "../../../../interfaces/interfaces";
import { Moment } from "moment";
import {
  PdfPasswordResult,
  checkPdfPassword,
} from "../../../../utils/pdfPassword";

const PDF_PASSWORD_STATES: Record<PdfPasswordResult, pdfProtectionStates> = {
  not_required: pdfProtectionStates.passwordNotRequired,
  validated: pdfProtectionStates.passwordValidated,
  required: pdfProtectionStates.passwordRequired,
  invalid: pdfProtectionStates.passwordValidationFailed,
  error: pdfProtectionStates.errorProcessing,
};

export const checkPDFProtection = async (
  file: File,
  password: string = ""
): Promise<string> => {
  if (!file) return "No file provided.";
  return PDF_PASSWORD_STATES[await checkPdfPassword(file, password)];
};

export const addDelay = (ms: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
};

export const getRestrictedIpDataPeriod = (
  yesterdayDate: Moment,
  configValue: string
) => {
  const endDate = yesterdayDate.clone();

  const normalized = configValue.trim().toUpperCase().replace(/[-\s]/g, "_");
  const match = normalized.match(/LAST_(\d+)_([A-Z]+)/);

  const amount = parseInt(match[1], 10);
  const unitRaw = match[2];

  const unitMap: Record<string, moment.unitOfTime.DurationConstructor> = {
    DAYS: "days",
    DAY: "days",
    MONTHS: "months",
    MONTH: "months",
    YEARS: "years",
    YEAR: "years",
    WEEKS: "weeks",
    WEEK: "weeks",
  };

  const unit = unitMap[unitRaw];

  let startDate = endDate.clone().subtract(amount, unit);

  if (unit === "months" || unit === "years") {
    startDate = startDate.startOf("month");
  }

  return {
    key: configValue,
    startDate: startDate,
    endDate: endDate,
  };
};

export const getMaxDataPeriod = (
  configValues: string[],
  yesterdayDate: Moment
): { key: string; start: string; end: string } => {
  const allPeriods = configValues.map((value) =>
    getRestrictedIpDataPeriod(yesterdayDate, value)
  );

  const max = allPeriods.reduce((minPeriod, current) => {
    return current.startDate.isBefore(minPeriod.startDate)
      ? current
      : minPeriod;
  });

  return {
    key: max.key,
    start: max.startDate.format("DD-MM-YYYY"),
    end: max.endDate.format("DD-MM-YYYY"),
  };
};
